<!-- 新闻标题列表 -->
<template>
  <div class="news-list">
    <ul
      class="list"
      :class="$route.path == '/party-building' ? 'party-building-ul' : ''"
    >
      <li
        class="space-between"
        v-for="(item, i) in listData"
        :key="i"
        @click="onListTitle(item)"
      >
        <p class="text_overflow">
          <i></i>
          {{ item.title }}
        </p>
        <span>{{
          item.publishedDate
            ? item.publishedDate.split(' ')[0]
            : item.createdDate.split(' ')[0]
        }}</span>
      </li>
    </ul>
    <div
      class="pagination"
      :class="
        $route.path == '/party-building' || $route.path == '/special-column'
          ? 'party-building-pagination'
          : ''
      "
    >
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[15, 25, 50, 60, 80, 100]"
        :page-size="params.size"
        layout="total, sizes, prev, slot, pager, next, jumper"
        :total="total"
        background
      >
        <span class="slot">
          {{ params.page + 1 }}/{{ Math.ceil(total / 15) }}
        </span>
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { getArticleList, getlatest } from '@/api/index'
import { mapState } from 'vuex'

export default {
  name: '',
  props: ['itemkey'],
  components: {},
  data() {
    return {
      params: {
        page: 0,
        size: 15
      },
      page: 1,
      listData: [],
      total: 0
    }
  },
  computed: {
    ...mapState(['tabItem', 'currentTab'])
  },

  watch: {
    'itemkey': {
      handler(val, oldval) {
        if (val) {
          this.params.page = 0
          this.getArticleList()
        }
      },
      immediate: false
    }
  },

  methods: {
    // 最新动态
    getlatest() {
      getlatest(this.params)
        .then((res) => {
          this.listData = res.list
          this.total = res.count
        })
        .finally(() => {})
    },
    // 前往详情页
    onListTitle(item) {
      if (item.linkTo) {
        window.open(item.linkTo, '_blank')
      } else {
        this.$router.push({
          path: '/details',
          query: {
            id: item.id,
            title: this.$route.query.title,
            tag: this.$route.query.tag
            // key: this.$route.query.key
          }
        })
      }
    },
    // 修改分页大小
    handleSizeChange(val) {
      this.params.page = 0
      this.params.size = val
      if (this.$route.query.tag == '最新动态') {
        this.getlatest()
      }
      if (this.$route.query.key) {
        this.getArticleList()
      }
      setTimeout(() => {
        window.scrollTo(0, 0)
      }, 200)
    },
    // 点击分页
    handleCurrentChange(val) {
      this.params.page = val - 1
      if (this.$route.query.tag == '最新动态') {
        this.getlatest()
      }
      if (this.$route.query.key) {
        this.getArticleList()
      }
      if (this.$route.query.tag == '党建动态') {
      } else {
        setTimeout(() => {
          window.scrollTo(0, 0)
        }, 200)
      }
    },
    // 获取文章内容
    getArticleList() {
      this.params.key = this.$route.query.key
      getArticleList(this.params)
        .then((res) => {
          this.listData = res.list
          this.total = res.count
        })
        .finally(() => {})
    }
  },
  activated() {},
  mounted() {
    if (this.$route.query.tag == '最新动态') {
      this.getlatest()
    }
    if (this.$route.query.key) {
      this.params.page = 0
      this.getArticleList()
    }
  },
  created() {}
}
</script>

<style lang="scss" scope>
.news-list {
  background-color: #fff;
  padding: 16px 24px;

  .list {
    min-height: 500px;
    width: 100%;
    display: flex;
    flex-direction: column;
    padding-left: 0;
    margin-bottom: 16px;
    li {
      height: 40px;
      border-bottom: 1px solid #d8d3d3d9;
      cursor: pointer;
      padding-left: 4px;

      &:hover {
        p {
          color: #14579e;
          font-weight: 600;
          transform: scale(1.01);
        }
      }

      p {
        width: 84%;
        color: #131414;
        line-height: 40px;
        transition: all 0.3s;

        i {
          display: inline-block;
          width: 6px;
          height: 6px;
          background-color: #d23938;
          border-radius: 50%;
          margin-right: 12px;
          margin-bottom: 2px;
        }
      }

      span {
        font-size: 18px;
        color: #888888;
        display: inline-block;
        line-height: 40px;
        width: 116px;
        text-align: right;
      }
    }
  }
  .party-building-ul {
    li {
      &:hover {
        p {
          color: #ea0803;
        }
      }
    }
  }
  .el-pagination {
    display: flex;
    align-items: center;
    .slot {
      display: none;
    }
  }

  .party-building-pagination {
    .el-select .el-input.is-focus .el-input__inner,
    .el-select .el-input__inner:focus,
    .el-input .el-input__inner:hover {
      border-color: #ea0803;
    }

    .el-input.is-active .el-input__inner,
    .el-input__inner:focus {
      border-color: #ea0803;
    }

    .el-pagination {
      padding: 0;
    }

    .el-pagination.is-background .btn-next,
    .el-pagination.is-background .btn-prev,
    .el-pagination.is-background .el-pager li {
      margin: 0 5px;
      background-color: #1414bd00;
      color: #606266;
      border: 1px solid #ea0803;
      min-width: 30px;
      border-radius: 2px;
    }

    .el-pagination.is-background .el-pager li:not(.disabled):hover {
      color: #ea0803;
    }

    .el-pagination.is-background .el-pager li:not(.disabled).active {
      background: #ea0803;
      color: #fff;

      &:hover {
        color: #fff;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .news-list {
    padding: 16px 0px;
    .list {
      li {
        height: 48px;
        padding: 0 16px;
        p {
          line-height: 48px;
        }
        span {
          font-size: 14px;
        }
      }
    }
  }
}
</style>
